import { render, staticRenderFns } from "./SimpleDateHeader.vue?vue&type=template&id=d5d68df2&scoped=true"
import script from "./SimpleDateHeader.vue?vue&type=script&lang=js"
export * from "./SimpleDateHeader.vue?vue&type=script&lang=js"
import style0 from "./SimpleDateHeader.vue?vue&type=style&index=0&id=d5d68df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5d68df2",
  null
  
)

export default component.exports